var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1925 4.87451H4.1925C3.0925 4.87451 2.2025 5.77451 2.2025 6.87451L2.1925 18.8745C2.1925 19.9745 3.0925 20.8745 4.1925 20.8745H20.1925C21.2925 20.8745 22.1925 19.9745 22.1925 18.8745V6.87451C22.1925 5.77451 21.2925 4.87451 20.1925 4.87451ZM20.1925 8.87451L12.1925 13.8745L4.1925 8.87451V6.87451L12.1925 11.8745L20.1925 6.87451V8.87451Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6ffa7984fe514ce0f6afb96fda333995.svg";
export { ForwardRef as ReactComponent };